import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { Label } from './Label';
import { PaddingStyle } from 'styles/PaddingStyle';
import { FieldError } from 'react-hook-form';

export const FormControl = ({
	required,
	label,
	labelWidth,
	desc,
	htmlFor,
	children,
	error,
	spaceMedium,
	alignRight,
}: {
	required?: boolean;
	label: string | ReactNode;
	labelWidth?: number;
	desc?: string | ReactNode;
	htmlFor: string;
	children?: ReactNode;
	error?: FieldError;
	spaceMedium?: boolean;
	alignRight?: boolean;
}) => {
	return (
		<div
			css={css`
				width: 100%;
			`}
		>
			<div
				css={css`
					width: 100%;
					display: flex;
					align-items: center;
				`}
			>
				<Label required={required} labelWidth={labelWidth} htmlFor={htmlFor} desc={desc}>
					{label}
				</Label>

				{spaceMedium ? <div css={PaddingStyle({ v: 12 })}>{children}</div> : children}
			</div>

			{error && (
				<div
					css={css`
						width: 100%;
						font-size: 13px;
						line-height: 16px;
						font-weight: 600;
						color: #ff6767;
						padding-top: 8px;
						padding-left: ${labelWidth}px;

						${alignRight &&
						css`
							text-align: right;
						`}
					`}
				>
					{error.message}
				</div>
			)}
		</div>
	);
};
